import useRefinementStore from "@/use-refinement-store";

const useRefinementEffects = () => {
  const setServices = useRefinementStore((store) => store.setServices);
  const setBounds = useRefinementStore((store) => store.setBounds);
  const setGeocodeContext = useRefinementStore(
    (store) => store.setGeocodeContext
  );

  return { setServices, setBounds, setGeocodeContext };
};

export default useRefinementEffects;
